import { render, staticRenderFns } from "./fourthStep.vue?vue&type=template&id=257a3262&scoped=true&"
import script from "./fourthStep.vue?vue&type=script&lang=js&"
export * from "./fourthStep.vue?vue&type=script&lang=js&"
import style0 from "./fourthStep.vue?vue&type=style&index=0&id=257a3262&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257a3262",
  null
  
)

export default component.exports